<template>
  <div id="app">
    <div>
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import MobileWidthMixin from '@/mixins/mobile'
import { dictsMapper } from '@/store/modules/dicts'
import { userMappers } from '@/store/modules/user'
import { isDev, vueDevToolsURL } from './config/urls'
import { affiliationsMapper } from './store/modules/affiliations'

const Mappers = Vue.extend({
  computed: {
    ...userMappers.mapState(['user']),
    ...userMappers.mapGetters(['isAuthenticated'])
  },
  methods: {
    ...affiliationsMapper.mapActions(['fetchAffiliations']),
    ...dictsMapper.mapActions([
      'fetchAlmostAllDicts',
      'fetchStudentGroups',
      'fetchCttDicts'
    ]),
    ...userMappers.mapActions(['fetchUser'])
  }
})
@Component({ mixins: [MobileWidthMixin] })
export default class App extends Mappers {
  private interval?: any

  private async created() {
    window.onbeforeunload = null

    if (this.isAuthenticated) {
      await Promise.all([
        this.fetchAlmostAllDicts(),
        this.fetchStudentGroups(),
        this.fetchCttDicts(),
        this.fetchAffiliations()
      ])
    }

    if (isDev) {
      const vueDevTools = document.createElement('script')
      vueDevTools.setAttribute('src', vueDevToolsURL)
      document.head.appendChild(vueDevTools)
    }
  }

  private beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@import './scss/app.scss';
@import '../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css';
@import '../node_modules/@it/vue-form-generator/dist/vfg.css';
@import './scss/vfg.scss';
</style>
